import {
  allRequest,
  deleteRequest,
  getRequest,
  postRequest,
  REQUEST_METHOD_DELETE,
  REQUEST_METHOD_GET
} from '../../../../middlewares/api/actions';
import {getAllCubeUrl, getCreateSeqMappingUrl, getCubeUrl, getDcsUrl, getFileMappingUrl, getSequenceMappingUrl} from '../../../../constants/urls';

export const FILE_MAPPING_LIST_FILE_MAPPINGS_READ = 'FILE_MAPPING_LIST_FILE_MAPPINGS_READ';
export const FILE_MAPPING_LIST_FILE_MAPPING_SHOW = 'FILE_MAPPING_LIST_FILE_MAPPING_SHOW';
export const FILE_MAPPING_LIST_FILE_MAPPING_HIDE = 'FILE_MAPPING_LIST_FILE_MAPPING_HIDE';
export const FILE_MAPPING_LIST_FILE_MAPPING_READ = 'FILE_MAPPING_LIST_FILE_MAPPING_READ';
export const FILE_MAPPING_LIST_FILE_MAPPING_DELETE = 'FILE_MAPPING_LIST_FILE_MAPPING_DELETE';
export const FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ = 'FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ';
export const FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL = 'FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL';
export const FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_FORM_SHOW = 'FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_FORM_SHOW';
export const FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_FORM_HIDE = 'FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_FORM_HIDE';
export const FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_SAVE = 'FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_SAVE';
export const FILE_MAPPING_LIST_SEQUENCE_MAPPING_SHOW = 'FILE_MAPPING_LIST_SEQUENCE_MAPPING_SHOW';
export const FILE_MAPPING_LIST_SEQUENCE_MAPPING_HIDE = 'FILE_MAPPING_LIST_SEQUENCE_MAPPING_HIDE';
export const FILE_MAPPING_LIST_SEQUENCE_MAPPING_DELETE = 'FILE_MAPPING_LIST_SEQUENCE_MAPPING_DELETE';
export const FILE_MAPPING_LIST_SEQUENCE_MAPPING_READ = 'FILE_MAPPING_LIST_SEQUENCE_MAPPING_READ';

export const readFileMappingListFileMappings = () => allRequest(
  FILE_MAPPING_LIST_FILE_MAPPINGS_READ,
  [REQUEST_METHOD_GET, REQUEST_METHOD_GET, REQUEST_METHOD_GET, REQUEST_METHOD_GET],
  [getAllCubeUrl(), getDcsUrl(), getFileMappingUrl(), getSequenceMappingUrl()]
);

export const showFileMappingListFileMapping = fileMappingId => ({
  type: FILE_MAPPING_LIST_FILE_MAPPING_SHOW,
  fileMappingId
});

export const hideFileMappingListFileMapping = () => ({
  type: FILE_MAPPING_LIST_FILE_MAPPING_HIDE
});

export const readFileMappingListFileMapping = fileMappingId =>
  getRequest(
    FILE_MAPPING_LIST_FILE_MAPPING_READ,
    getFileMappingUrl(fileMappingId)
  );

export const readFileMappingListFileMappingCube = cubeId =>
  getRequest(
    FILE_MAPPING_LIST_FILE_MAPPING_CUBE_READ,
    getCubeUrl(cubeId)
  );

export const deleteFileMappingListFileMapping = fileMappingId =>
  deleteRequest(
    FILE_MAPPING_LIST_FILE_MAPPING_DELETE,
    getFileMappingUrl(fileMappingId),
    t => ({
      success: t('scenes.dataManager.fileMapping.list.messages.fileMappingDelete.success')
    })
  );

export const deleteFileMappingListFileMappingAll = fileMappingIds =>
  allRequest(
    FILE_MAPPING_LIST_FILE_MAPPING_DELETE_ALL,
    fileMappingIds.map(() => REQUEST_METHOD_DELETE),
    fileMappingIds.map(id => getFileMappingUrl(id)),
    null,
    t => ({
      success: t('scenes.dataManager.fileMapping.list.messages.fileMappingDeleteAll.success')
    })
  );

export const showNewSequenceMappingForm = () => ({
  type: FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_FORM_SHOW
});  

export const hideNewSequenceMappingForm = () => ({
  type: FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_FORM_HIDE
});

export const saveNewSequenceMapping = (idCube, name, description, mappingsIDs, pluginUid = null) =>
  postRequest(
    FILE_MAPPING_LIST_NEW_SEQUENCE_MAPPING_SAVE,
    getCreateSeqMappingUrl(),
    {
      IDCube: idCube,
      Name: name,
      Description: description,
      mappingsIDs: mappingsIDs,
      PluginUid: pluginUid
    },
    t => ({
      success: t('scenes.dataManager.fileMapping.list.messages.sequenceMappingCreate.success')
    })
  );

export const showFileMappingListSequenceMapping = sequenceMappingId => ({
  type: FILE_MAPPING_LIST_SEQUENCE_MAPPING_SHOW,
  sequenceMappingId
});

export const hideFileMappingListSequenceMapping = () => ({
  type: FILE_MAPPING_LIST_SEQUENCE_MAPPING_HIDE
});  

export const deleteFileMappingListSequenceMapping = sequenceMappingId =>
  deleteRequest(
    FILE_MAPPING_LIST_SEQUENCE_MAPPING_DELETE,
    getSequenceMappingUrl(sequenceMappingId),
    t => ({
      success: t('scenes.dataManager.fileMapping.list.messages.sequenceMappingDelete.success')
    })
  ); 

export const readFileMappingListSequenceMapping = sequenceMappingId =>
  getRequest(
    FILE_MAPPING_LIST_SEQUENCE_MAPPING_READ,
    getSequenceMappingUrl(sequenceMappingId)
  );
  
    
